const navBell_popper = (theme: any) => {
    return {
        marginTop: "4px",
        [theme.breakpoints.down('sm')]: {
            [theme.breakpoints.down(325)]: {
                width: "250px !important",
            },
            [theme.breakpoints.up(325)]: {
                width: "300px !important",
            },
        },
        [theme.breakpoints.up('sm')]: {
            width: "400px !important",
        },
    }
}

const navBell_btnBox = () => {
    return {
        display: "flex",
        margin: "0px 0.25rem",
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
        padding: "0.5rem 0.5rem 0rem 0.5rem",
        "&:hover": {
            cursor: "pointer",
            backgroundColor: "#e5e7eb",
        }
    }
}

const navBell_itemMenu = () => {
    return {
        width: "100%",
        display: "flex",
        padding: "8px 4px",
        maxHeight: "167px",
        borderRadius: "8px",
        alignItems: "center",
        "&:hover": {
            cursor: "pointer",
            backgroundColor: "#c6deff",
        }
    }
}

const navBell_icon = () => {
    return {
        color: "#626262",
        "&:hover": {
            color: "#42a5f5",
        }
    }
}

const navBell_text = () => {
    return {
        opacity: 1,
        fontWeight: 400,
        lineHeight: 1.5,
        color: "#344767",
        fontSize: "0.875rem",
        textTransform: "none",
        textDecoration: "none",
        verticalAlign: "unset",
        fontFamily: "Open Sans",
        letterSpacing: "0.02857em",
    }
}

const navBell_btn_ReadAll = () => {
    return {
        right: "18px",
        display: "flex",
        position: "absolute",
        "&:hover #text_readAll": {
            cursor: "pointer",
            fontWeight: "bold",
            textDecoration: "underline",
        },
    }
}


export {
    navBell_btnBox,
    navBell_btn_ReadAll,
    navBell_icon,
    navBell_itemMenu,
    navBell_popper,
    navBell_text,
}